import {
    LEGACY_LOCALE_STORAGE_KEY,
    LOCALE_STORAGE_KEY,
    DEFAULT_LOCALE,
    isSupportedLocale,
    SupportedLocale,
} from './config';

const LEGACY_NUMERIC_MAP: Record<string, SupportedLocale> = { '1': 'sq', '2': 'en' };

export function migrateLocaleStorage(): SupportedLocale {
    if (typeof window === 'undefined' || !window.localStorage) {
        return DEFAULT_LOCALE;
    }

    const current = safeGet(LOCALE_STORAGE_KEY);
    if (current && isSupportedLocale(current)) {
        safeRemove(LEGACY_LOCALE_STORAGE_KEY);
        return current;
    }

    const next = readLegacy();
    safeSet(LOCALE_STORAGE_KEY, next);
    safeRemove(LEGACY_LOCALE_STORAGE_KEY);
    return next;
}

function readLegacy(): SupportedLocale {
    const raw = safeGet(LEGACY_LOCALE_STORAGE_KEY);
    if (!raw) return DEFAULT_LOCALE;

    try {
        const parsed = JSON.parse(raw);

        if (parsed && typeof parsed === 'object' && 'value' in parsed) {
            const mapped = LEGACY_NUMERIC_MAP[String(parsed.value)];
            if (mapped) return mapped;
        }

        if (typeof parsed === 'string') {
            if (parsed === 'al') return 'sq';
            if (isSupportedLocale(parsed)) return parsed;
        }
    } catch {
        if (raw === 'al') return 'sq';
        if (isSupportedLocale(raw)) return raw;
    }

    return DEFAULT_LOCALE;
}

function safeGet(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
}

function safeSet(key: string, value: string): void {
    try { localStorage.setItem(key, value); } catch { /* quota or disabled storage — harmless */ }
}

function safeRemove(key: string): void {
    try { localStorage.removeItem(key); } catch { /* harmless */ }
}
